import { BaseWidget, WidgetCategory, WidgetDefinition } from './base.types';

export enum VennSubType {
  Venn = 'VENN',
}

export type VennTypeWidget = BaseWidget & {
  category: WidgetCategory.Venn;
  type: VennSubType;
  definition: WidgetDefinition & { custom?: {} };
};
